import type { ReactElement, ReactNode } from 'react';

type Props = {
  href: string;
  children: ReactNode;
};

function Link({ href, children }: Props): ReactElement {
  return (
    <a className="c-footer__link" href={href}>
      {children}
    </a>
  );
}

export default Link;
